<template>
  <div class="content">
    <div class="search-bar">
      <div class="row">
        <div class="col-md-4">
          <ArtistSelect
            v-model="selectedUnitId"
            @memberChangeEvent="onMemberChange"
            :include-unit-artist="true"
            :is-filter="true"
            :showMembers="false"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          />
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">상태</h4>
          <div class="row">
            <el-select @change="onClickSearch" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="selectedState">
              <el-option v-for="option in stateOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">검색어</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-input placeholder="검색어를 입력해 주세요" v-model="searchText" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <base-button @click.self="onClickSearch" native-type="submit" type="primary">검색</base-button>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="topic-cell" v-for="chitchat in chitchats" :key="chitchat.id">
        <div class="body">
          <card class="topic-card">
            <div class="metadata">
              <div class="title">
                <span class="id">[{{ chitchat.id }}] </span>
                <span class="name">{{ chitchat.title }}</span>
              </div>
              <div class="stats">
                <span>{{ chitchat.viewCount }} 뷰 / </span>
                <span>{{ chitchat.likeCount }} 좋아요 / </span>
                <span>{{ chitchat.commentCount }} 댓글 / </span>
                <span>{{ chitchat.pinCount }} 저장</span>
              </div>
              <div class="regTime">{{ chitchat.regTime }}</div>
            </div>
          </card>
        </div>

        <div class="delete">
          <base-button class="btn" @click.prevent="onClickDetail(chitchat)">상세</base-button>
          <base-button class="btn-danger" @click.prevent="onClickDelete(chitchat)">삭제</base-button>
        </div>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>

<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Toast } from "@/util/Toast";
import moment from "moment";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import { BasePagination, Card } from "@/components/index";
import swal from "sweetalert2";
import { formatDateTime } from "@/util/DateUtils";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import { UserData } from "@/util/UserData";
import { TopicStateOptions } from "@/common/TopicState";

const DEFAULT_UNIT_ID = 1;

export default {
  name: "ChitchatContents",
  components: {
    ArtistSelect,
    Card,
    BasePagination,
  },
  async created() {
    const fallbackUnitId = UserData.get(UserData.LAST_UNIT_ID, DEFAULT_UNIT_ID);

    if (_.isEmpty(this.$route.query)) {
      await this.$router.replace(`/chitchat/contents?unitId=${fallbackUnitId}&state=1&popularity=0`);
      return;
    }

    const { unitId, state, searchText } = this.$route.query;

    this.selectedUnitId = unitId ? parseInt(unitId, 10) : fallbackUnitId;
    this.selectedState = state ? parseInt(state, 10) : 1;
    this.searchText = searchText || null;

    await this.getChitchats();
  },
  watch: {
    currentPage: {
      handler() {
        this.getChitchats();
      },
    },
  },
  data() {
    return {
      stateOptions: TopicStateOptions,
      selectedUnitId: DEFAULT_UNIT_ID,
      selectedPopularity: 0,
      selectedState: 1,
      searchPeriod: [],
      searchText: null,
      currentPage: 1,
      totalPages: 1,
      chitchats: [],
    };
  },
  methods: {
    async onMemberChange(change) {
      this.selectedUnitId = change.unitId;

      await this.onClickSearch();
    },
    async onClickSearch() {
      const queryParams = {
        unitId: this.selectedUnitId,
        state: this.selectedState,
        searchText: this.searchText || undefined,
      };

      if (this.searchPeriod) {
        queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).format("YYYY-MM-DD") : undefined;
        queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).format("YYYY-MM-DD") : undefined;
      }

      try {
        await this.$router.push(`/chitchat/contents?${URLUtils.objectToQueryString(queryParams)}`);
      } catch (err) {
        await this.getChitchats();
      }
    },
    getSearchParams() {
      return {
        unitId: this.selectedUnitId,
        state: this.selectedState,
        isHot: this.selectedPopularity === 1,
        currentPage: this.currentPage || 1,
        searchText: this.searchText || undefined,
      };
    },
    async getChitchats() {
      try {
        const queryParams = this.getSearchParams();
        const result = await this.$axios.get(`/chitchats?${URLUtils.objectToQueryString(queryParams)}`);
        this.chitchats = result.data.data.chitchats.map((row) => {
          row.regTime = formatDateTime(row.regTime);
          return row;
        });
        this.totalPages = Number(result.data.data.page);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickDetail(chitchat) {
      this.$router.push(`/chitchat/detail/${chitchat.id}`);
    },
    async onClickDelete(chitchat) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${chitchat.title} 잡담을 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              Toast.success("잡담이 삭제되었습니다.");
              await this.$axios.delete(`/chitchats/${chitchat.id}`);
              await this.getChitchats();
            } catch (err) {
              Toast.error("잡담 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  margin-bottom: 10px;
}

.list {
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 100%;

  .topic-cell {
    padding: 3px;
    flex-direction: column;
    flex-basis: 25%;
    max-height: 420px;
    min-width: 256px;
    margin-bottom: 30px;

    div {
      min-height: 30px;
    }

    .topic-card {
      margin-bottom: 0;
    }

    .cover-img-area {
      min-height: 150px;
      vertical-align: middle;

      .a-or-b {
        img {
          flex: auto;
          width: 100px;
          height: 100px;
          object-fit: cover;
        }
        img:nth-child(2) {
          margin-right: 5px;
        }
      }

      .tips {
        img {
          flex: auto;
          width: 100px;
          height: 100px;
          object-fit: cover;
        }
      }
    }

    .metadata {
      min-height: 100px;
    }

    .delete {
      margin-top: 5px;
    }
  }
}
</style>
